import React from 'react';
import '../css/Hotels.css';
import firebase from 'firebase';
import moment from 'moment';

import HotelItem from './HotelItem.js';

class Hotels extends React.Component {
  state = {
    currentUser: null,
    currentUserId: null,
    userArray: [],
    hotel: [],
    loc: '',
    rating: null,
    display: false,
    checkIn: null,
    checkOut: null,
  }
  componentDidMount() {
    firebase
      .firestore()
        .collection('hotels')
          .onSnapshot((result) => {
            console.log(result);
            let docs = result.docs;
            console.log(docs);
            let hotels = docs.map((doc, pos) => {
              let data = doc.data();
              data.id = doc.id;
              return data;
            });
            this.setState({
              hotel: hotels,
            })
            console.log(this.state.hotel);
          })
    firebase.auth().onAuthStateChanged(user => {
      if(user) {
        this.setState({currentUser: user});
        console.log(user);
        console.log(user.displayName);
      }
    })
    firebase
      .firestore()
        .collection('users')
          .onSnapshot((result) => {
            console.log(result);
            let docs = result.docs;
            let users = docs.map((doc, pos) => {
              let data = doc.data();
              data.id = doc.id;
              return data;
            });
            this.setState({
              userArray: users,
            });
            console.log(this.state.userArray);
          })
  }
  render() {
    console.log(this.state.currentUser);
    let userId = this.getUserId(this.state.currentUser);
    let userHotel = this.getUserHotel(userId);
    console.log(userId);
    console.log(userHotel);
    let hotels = this.state.hotel.map((hotel, pos) => {
      if(this.state.display) {
          if(this.state.loc == hotel.Location && this.state.rating <= hotel.Star) {
            return(
              <HotelItem rating={this.state.rating} checkin={this.state.checkIn} checkout={this.state.checkOut} bookedHotel={userHotel} currentUser={this.state.currentUser} currentUid={userId} hotel={hotel} loc={this.state.loc} key={pos}/>
            )
          }
        }
    });
    return(
      <div>
        <div className="logo_name">
        <div className="logo-img">
          <img src="logo.png" />
        </div>
          <div className="logo_text">
            <h1 className="name">सारथी</h1>
            <h3 className="slogan">Your Travel Partner!</h3>
          </div>
        </div>
        <div className="hotels">
          <div className="hotelTitle">
            <strong>Hotels:</strong>
          </div>
          <input
          type="text"
          name="placesToSearch"
          value={this.state.loc}
          onChange={(e)=>{this.setState({loc:e.target.value})}}
          placeholder="Enter a location...e.g: Chennai, Delhi, Mumbai*" className="searchPlace" />
          <br />
          <p><center>*Only these cities are working for demonstration purpose</center></p>
          <br />
          <div class="checkInOut">
            <label className="in">
              Check-In
              <input type="date" min={moment().format('YYYY-MM-DD')} name="checkIn" value={this.state.checkIn} onChange={(e)=>{this.setState({checkIn: e.target.value})}} />
            </label>
            <label className="out">
              Check-Out
              <input type="date" min={moment().format('YYYY-MM-DD')} name="checkOut" value={this.state.checkOut} onChange={(e)=>{this.setState({checkOut: e.target.value})}} />
            </label>
          </div>

          <br />

          <div class="filters">
            <span>Sort by<i class="fa fa-filter"></i></span>
            <select onChange={(e)=>{this.setState({rating: e.target.value})}}>
              <option value="select">Select</option>
              <option value="4.5">4.5 star</option>
              <option value="4">4 star</option>
              <option value="3.5">3.5 star</option>
            </select>
          </div>

          <br />
          <br />

            <div className="searchBtn">
              <button type="submit" onClick={this.onSearch}>Search</button>
            </div>

        </div>

        <React.Fragment>
          {hotels}
        </React.Fragment>
      </div>
    );
  }
  onSearch = () => {
    if((this.state.checkIn && this.state.checkOut) && (this.state.checkOut > this.state.checkIn)) {
      this.setState({
        display: true,
      })
    } else {
      alert("Please mention check-in and check-out dates properly and then try");
    }
  }
  getUserId = (cu) => {
    let uid = null;
    if(cu) {
      for(var i = 0; i<this.state.userArray.length; i++) {
        if(this.state.userArray[i].name) {
          if(this.state.userArray[i].uid == cu.uid) {
            return(this.state.userArray[i].uid);
          }
        }
      }
    } else {
      return null;
    }
  }
  getUserHotel = (uid) => {
    let userHotel = null;
    for(var i = 0; i<this.state.userArray.length; i++) {
      if(this.state.userArray[i].uid == uid) {
        userHotel = this.state.userArray[i].hotel;
      }
    }
    return userHotel;
  }
}
export default Hotels;
